module.exports = __webpack_public_path__ + "img/github.logo.c93f635b.svg";